module.exports = __webpack_public_path__ + "static/media/LEASH_TRAINED.cb7eab32.svg";